import { BeltSyllabus } from './types';

export const redBeltBlackTag: BeltSyllabus = {
    id: 'red-black',
    name: 'Red Belt Black Tag',
    color: '#8b0000',
    theoryUnder13: [],
    theoryOver13: [
        {
            title: 'Theory',
            subTitle: 'Those going for 1st degree should learn',
            items: [
                {
                    question: 'Terminology for stances (weight distribution, angles and distances), all hand techniques/tools',
                    answer: ' '
                },
                {
                    question: 'All foot techniques/tools',
                    answer: ' '
                },
                {
                    question: 'Pattern meanings (all so far)',
                    answer: ' '
                },
                {
                    question: 'Meanings of the belt colours',
                    answer: ' '
                },
                {
                    question: 'Motions - Korean Name and the description of them',
                    answer: ' '
                },
                {
                    question: 'Oath & Tenets (Tenets in Korean)',
                    answer: ' '
                },
                {
                    question: 'Significance of 24 Patterns',
                    answer: ' '
                },
                {
                    question: 'Significance of the Belt wrapped around the waist once',
                    answer: ' '
                },
                {
                    question: 'Current Board Members of ITF England',
                    answer: ' '
                },
                {
                    question: 'Current Board Members of ITF',
                    answer: ' '
                },
                {
                    question: 'Endeavour to learn any additional stances/techniques, also the terminology for all the new movements in your patterns, as well as their applications',
                    answer: ' '
                }
            ]
        },
        {
            title: 'Theory Resources',
            items: [
                { question: 'The Vision TKD Association Black Book or AETA White Book', answer: ' ' },
                { question: 'Path to Black Belt', answer: ' ' },
                { question: 'Condensed Encyclopaedia 1999 version', answer: ' ' },
                { question: 'ITF International Taekwon-Do Federation', answer: 'https://itftkd.sport/' },
                { question: 'ITF England', answer: 'https://www.itfengland.com/' }
            ]
        }
    ],
    practical: [
        {
            title: 'Kicking Combinations (9%)',
            items: [
                { question: 'Front Leg Side Front Kick, Rear Leg Turning Kick', answer: ' ' },
                { question: 'Front Leg Downward Kick, Rear Leg Side Piercing Kick', answer: ' ' },
                { question: 'Front Leg Turning Kick, Back Kick', answer: ' ' },
                { question: 'Front Leg Side Piercing Kick, Reverse Turning Kick', answer: ' ' },
                { question: 'Rear Leg Pressing Kick, Side Piercing Kick (Consecutive)', answer: ' ' },
                { question: 'Rear Leg Crescent Kick, Side Piercing Kick (Consecutive)', answer: ' ' }
            ]
        },
        {
            title: 'Patterns (38%)',
            subTitle: 'Chon-Ji to Choong-Moo',
            items: [
                { question: 'Chon-Ji', answer: '3%' },
                { question: 'Dan-Gun', answer: '3%' },
                { question: 'Do-San', answer: '3%' },
                { question: 'Won-Hyo', answer: '4%' },
                { question: 'Yul-Gok', answer: '4%' },
                { question: 'Joong-Gun', answer: '5%' },
                { question: 'Toi-Gye', answer: '5%' },
                { question: 'Hwa-Rang', answer: '5%' },
                { question: 'Choong-Moo', answer: '6%' }
            ]
        },
        {
            title: 'Self-Defence (18%)',
            items: [
                { question: 'Push Against Shoulder - single or two hands', answer: ' ' },
                { question: 'Front and Rear Single & Twin Lapel Grabs', answer: ' ' },
                { question: 'Front and Rear Choke Holds', answer: ' ' },
                { question: 'Front and Rear Guillotine', answer: ' ' },
                { question: 'Swinging Punch to the Head', answer: ' ' },
                { question: 'Front Kick & Turning Kick - waist level and below', answer: ' ' }
            ]
        },
        {
            title: 'Sparring (14%)',
            items: [
                { question: '3 Step Sparring', answer: ' ' },
                { question: '2 Step Sparring', answer: ' ' },
                { question: '1 Step Sparring', answer: ' ' },
                { question: 'Competition Sparring', answer: ' ' },
                { question: '2 V 1 Sparring', answer: ' ' }
            ]
        },
        {
            title: 'Special Technique (9%)',
            subTitle: [
                'Choose 3 out of 5 Techniques',
                'Minimum Head Height (except High Kick)',
                '50yrs+ - Solar Plexus Height',
                '3 Attempts'
            ],
            items: [
                { question: 'Flying Turning Kick (Twin Foot Take-Off)', answer: ' ' },
                { question: 'Flying Side Kick', answer: ' ' },
                { question: 'Jump Reverse Turning Kick', answer: ' ' },
                { question: 'Jump Back Kick', answer: ' ' },
                { question: 'Flying High Kick (your height + your extended arm to your fist)', answer: ' ' }
            ]
        },
        {
            title: 'Power Test - Hand (6%)',
            subTitle: [
                'Choose 2 out of 4 Techniques',
                'Minimum 1 White Board for 16yrs+',
                'Minimum 1 Cream Board for Females/15yrs-',
                'Select more boards to receive a higher %',
                '3 Attempts'
            ],
            headerBackgroundColor: '#d6eaf8',
            items: [
                { question: 'Punch', answer: ' ' },
                { question: 'Knifehand', answer: ' ' },
                { question: 'Sidefist', answer: ' ' },
                { question: 'Elbow', answer: ' ' }
            ]
        },
        {
            title: 'Power Test - Foot (6%)',
            subTitle: [
                'Choose 2 out of 4 Techniques',
                'Minimum 2 White Boards for 16yrs+',
                'Minimum 1 White Board for Females/15yrs-',
                'Select more boards for a higher %',
                'Select less boards for half the %',
                '3 Attempts'
            ],
            headerBackgroundColor: '#d6eaf8',
            items: [
                { question: 'Side Piercing Kick (Front or Rear Leg)', answer: ' ' },
                { question: 'Turning Kick', answer: ' ' },
                { question: 'Reverse Turning Kick', answer: ' ' },
                { question: 'Side Back Kick', answer: ' ' }
            ]
        },
        {
            title: 'Theory',
            items: [
                { question: 'Theory Paper - must get 60% before the practical exam', answer: ' ' }
            ]
        }
    ]
};
